// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  AR_MOBILE2: '[data-fragment="ARChoose.armobile2"]',
  OTHER2: '[data-fragment="ARChoose.other2"]',
};

export default class ARChoose2 extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      device: 'other',
    };
  }

  getDeviceLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'intent://arvr.google.com/scene-viewer/1.0?file=https://www.cafedock.com/img/virtual-reality-2/Dallmayr_Automat.glb#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://www.cafedock.com/?openPopup=model2;end;';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'https://www.cafedock.com/img/virtual-reality-2/Dallmayr_Automat.usdz';
    }
    return '#';
  }

  didMount() {
    this.linkAr = this.element.querySelector(fragments.AR_MOBILE2).querySelector('a');
    this.linkOther = this.element.querySelector(fragments.OTHER2).querySelector('a');
    this.setState({ deviceLink: this.getDeviceLink() });
  }

  update() {
    const { deviceLink } = this.state;
    if (deviceLink == '#') {
      this.linkOther.classList.remove('d-none');
    } else {
      this.linkAr.classList.remove('d-none');
      this.linkAr.setAttribute('href', deviceLink);
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ARChoose2.js